<template>
  <v-dialog persistent v-model="value" max-width="290">
    <v-form @submit.prevent="save">
      <v-card>
        <v-card-title class="headline">{{$t('Pages.UserCheckoutForms.return_expandable')}}</v-card-title>

        <v-card-text>
          <v-layout column wrap>
            <v-flex xs12 md5>
              <v-textarea
                  v-model="newReturn.note"
                  :label="$t('Pages.UserCheckoutForms.model.note')"
                  color="indigo"
                  name="note"
              />
            </v-flex>
            <v-flex xs12 md5>
              <v-text-field
                min="1"
                :max="maxQuantity"
                v-model="newReturn.quantity"
                :label="$t('Pages.UserCheckoutForms.model.quantity')"
                v-validate="'required|min_value:1|max_value:' + maxQuantity"
                :error-messages="errors.first('quantity')"
                type="number"
                color="indigo"
                name="quantity"
              />
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn @click="close">
            {{$t('Core.Fields.close')}}
          </v-btn>

          <v-btn dark color="success dark1" type="submit">
            {{$t('Core.Fields.save')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
  import _ from 'lodash';
  export default {
  components: {},
  props: ['userCheckoutForm', 'value', 'currentStatus'],
  data: () => ({
    newReturn: {},
    maxQuantity: 1
  }),
  methods: {
    close(){
      this.$emit('close')
      this.newReturn = {};
      this.$validator.reset();
    },
    save(){
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.newReturn.userCheckoutFormId = this.userCheckoutForm.id;

          this.repositories.userCheckoutForm.returnExpandable(this.newReturn).then((response) => {
            this.$toast.success(response.data.message);
            this.$emit('refresh');
            this.close();
          })
      }});
    }
  },
  watch: {
    value() {
      if (this.value) {
        this.maxQuantity = this.userCheckoutForm.warehouseOutTransactions[0].quantity * -1;
      }
    }
  }
}
</script>

<style lang="scss">

</style>